import { render, staticRenderFns } from "./ConfirmGrouping.vue?vue&type=template&id=39ecf1bf&scoped=true"
import script from "./ConfirmGrouping.vue?vue&type=script&lang=js"
export * from "./ConfirmGrouping.vue?vue&type=script&lang=js"
import style0 from "./ConfirmGrouping.vue?vue&type=style&index=0&id=39ecf1bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ecf1bf",
  null
  
)

export default component.exports